module.exports = __webpack_public_path__ + "media/src/ui/images/tmDeviceTablet-cafb4b629e1bc85d87c38bba0473aa3f.svg";